<sigv-data-table
  [(value)]="files"
  [columns]="fileColumns"
  [(selection)]="selectedFiles"
  [selectable]="!readonly"
  [editable]="!readonly"
  [canDelete]="!readonly"
  dataKey="id"
  [displayRowChkboxFunc]="displayRowChkboxFunc"
  [displayRowEditBtnFunc]="displayRowEditBtnFunc"
  [reorderableColumns]="false"
  [validateRowDeleteFunc]="pageActions.onRowDelete"
  (valueChange)="onValueChange($event)"
  (rowEditSave)="onRowEditSave($event)"
  (validateDeleteFailMsg)="onRowDeleteMsg($event)"
>
  <ng-template pTemplate="toolbar">
    <label
      *ngIf="selectedFiles.length === 0 && !readonly"
      pButton
      type="button"
      label="{{ 'Upload' | translate }}"
      icon="pi pi-cust-upload"
      class="p-button-action p-button-outlined p-content-button mr-10"
    >
      <input
        #fileInput
        type="file"
        style="display: none"
        [multiple]="true"
        [accept]="acceptTypes"
        (change)="onUploadBtnClick($event)"
      />
    </label>
    <ng-container *ngIf="toolbarTemplate">
      <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
    </ng-container>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-fileInfo
    let-rowIndex="rowIndex"
    let-editing="editing"
    let-columns="columns"
  >
    <ng-container *ngIf="readonly; else tableRow">
      <tr>
        <ng-container *ngTemplateOutlet="tableRow"></ng-container>
      </tr>
    </ng-container>
    <ng-template #tableRow>
      <ng-container *ngFor="let col of columns">
        <td [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'fileId'">
            <i
              *ngIf="checkIsShowFileTypeIcon(fileInfo); else showUnknow"
              [ngClass]="getFileTypeIconStyleClassName(fileInfo)"
            ></i>
            <ng-template #showUnknow>
              <i
                *ngIf="!checkIsPhoto(fileInfo); else showImage"
                class="icon-unknow"
              ></i>
            </ng-template>
            <ng-template #showImage>
              <img
                [src]="fileInfo.url | imageUrl | async"
                alt="photo"
                style="max-width: 60px; max-height: 60px"
                (click)="onRowImageClick(fileInfo)"
              />
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'fileName'">
            <ng-container *ngIf="!editing; else fileNameInput">
              <a sigvVisitedLink class="link" (click)="downloadFile(fileInfo)">
                {{ getDisplayFileName(fileInfo) | replaceNullWith : '-' }}
              </a>
            </ng-container>
            <ng-template #fileNameInput>
              <input
                pInputText
                [(ngModel)]="fileInfo.fileName"
                (ngModelChange)="onFileInfoChange(fileInfo)"
              />
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'uploadTime'">
            {{
              fileInfo.uploadTime
                | date : envConfig.format.datetime
                | replaceNullWith : '-'
            }}
          </ng-container>
          <ng-container *ngSwitchCase="'fileSize'">
            {{ fileInfo.fileSize | fileSize | replaceNullWith : '-' }}
          </ng-container>
          <ng-container *ngSwitchCase="'description'">
            <ng-container *ngIf="!editing; else fileDescInput">
              <sigv-collapsible-content-container>
                <ng-template pTemplate="content">
                  {{ fileInfo.description | replaceNullWith : '-' }}
                </ng-template>
              </sigv-collapsible-content-container>
            </ng-container>
            <ng-template #fileDescInput>
              <input
                pInputText
                [(ngModel)]="fileInfo.description"
                maxlength="100"
                (ngModelChange)="onFileInfoChange(fileInfo)"
              />
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'processor'">
            {{
              (!fileInfo.editor ? fileInfo.creator : fileInfo.editor)
                | userComposer
                | async
                | replaceNullWith : '-'
            }}
          </ng-container>
          <ng-container *ngSwitchDefault>{{
            fileInfo[col.field]
          }}</ng-container>
        </td>
      </ng-container>
    </ng-template>
  </ng-template>
</sigv-data-table>
<sigv-content-dialog
  [(visible)]="showDialog"
  header="{{ 'Upload' | translate }}"
  (confirm)="onUploadDialogConfirm()"
  (cancel)="onUploadDialogCancel()"
>
  <p-table [value]="tmpUploadFiles" dataKey="code">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 120px">{{ 'IMG' | translate }}</th>
        <th>{{ 'File Name' | translate }}</th>
        <th>{{ 'File Size' | translate }}</th>
        <th>{{ 'File Description' | translate }}</th>
        <th *ngIf="showProcessor">{{ 'Processor' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-fileInfo let-rowIndex="rowIndex">
      <tr>
        <td>
          <i
            *ngIf="checkIsShowFileTypeIcon(fileInfo); else showTmpUnknow"
            [ngClass]="getFileTypeIconStyleClassName(fileInfo)"
          ></i>
          <ng-template #showTmpUnknow>
            <i
              *ngIf="!checkIsPhoto(fileInfo); else showTmpImage"
              class="icon-unknow"
            ></i>
          </ng-template>
          <ng-template #showTmpImage>
            <img
              [src]="fileInfo.url | imageUrl | async"
              alt="photo"
              style="max-width: 60px; max-height: 60px"
            />
          </ng-template>
        </td>
        <td>
          <input
            pInputText
            [(ngModel)]="fileInfo.fileName"
            (ngModelChange)="onFileInfoChange(fileInfo)"
          />
        </td>
        <td>{{ fileInfo.fileSize | fileSize | replaceNullWith : '-' }}</td>
        <td>
          <input
            pInputText
            type="text"
            placeholder="Here to leave your notes..."
            [(ngModel)]="fileInfo.description"
            maxlength="100"
          />
        </td>
        <td *ngIf="showProcessor">
          {{
            (!fileInfo.editor ? fileInfo.creator : fileInfo.editor)
              | userComposer
              | async
              | replaceNullWith : '-'
          }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</sigv-content-dialog>

<p-galleria
  *ngIf="displayImages.length > 0"
  [value]="displayImages"
  [(visible)]="showGalleria"
  [responsiveOptions]="responsiveOptions"
  [containerStyle]="{ 'max-width': '50%' }"
  [numVisible]="9"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [baseZIndex]="100000"
  [showThumbnailNavigators]="false"
  [activeIndex]="currentDisplayImgIdx"
>
  <ng-template pTemplate="item" let-item>
    <img
      [src]="item.previewImageSrc | imageUrl | async"
      style="max-width: 100%; display: block; max-height: 60vh"
    />
  </ng-template>
  <ng-template pTemplate="thumbnail" let-item>
    <div class="p-grid p-nogutter p-justify-center">
      <img
        [src]="item.thumbnailImageSrc | imageUrl | async"
        style="width: 90%; display: block"
      />
    </div>
  </ng-template>
</p-galleria>
